// extracted by mini-css-extract-plugin
module.exports = {"body":"JoinDiscordModal_body__1BxWQ","ctaButton":"JoinDiscordModal_ctaButton__2mTkq","secondaryButton":"JoinDiscordModal_secondaryButton__DIfbt"};